import { Component, OnInit, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { courses } from '../../models/courses';
import {Configuration} from "../../config/config";
import { LearnerService } from '../../Services/learner.service';
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from "@angular/forms";
declare var $;
declare let paypal: any;

@Component({
  selector: 'app-isolated-subscription',
  templateUrl: './isolated-subscription.component.html',
  styleUrls: ['./isolated-subscription.component.css'],
  providers: [LearnerService]
})
export class IsolatedSubscriptionComponent implements OnInit {

  screenWidth: number = 1366;
  screenHeight: number;
  redirectUrl: string = '';
  course_id: string = '';
  certId: string = '';
  communityId: string = '';
  isFreeLicenseSelected: boolean = false;
  allLicense = [];
  buttonTitle : any;
  currentCourse: any ;
  couponValidationMsg : string = "";
  coupon_code;
  coupon_id;
  TotalPrice = 0;
  DiscountPrice = 0;
  InvalidCoupon = false;
  agreement: any;
  selectedLicense: any = undefined;
  licensePrice: any = 0;
  valArr = [];
  userID: string = '';
  appliedCoupons = 0;
  subscribeLicIdList = [];
  modulesNoData:boolean = false;
  module_name : any;
  subStatusCode : string = "";
  courseArr : Array<courses> = [];
  progressArr : Array<any> = [];
  type: string = 'course';
  alertMsg: string = '';
  coursesNamesStr: String = '';

  constructor(private router : Router, private learnerService : LearnerService,private route: ActivatedRoute, private translateService : TranslateService) {
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translateService.use(lang_name);
    this.translateService.reloadLang(lang_name);
  }

  @ViewChild('subscriptionForm') subscriptionForm: NgForm;

  ngOnInit() {
    $(document).ready(function() {
      $("#disablePrevent").on("contextmenu",function(){
        return false;
      });
    });
    $("header").css('display','none');
    $("footer").css('display','none');
    window.name = 'isolatedSubscriptionScreen';
    $("#preloader").css('display','block');
    this.coursesNamesStr = '';
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;
    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      } else {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      }
    });
    this.route.params.subscribe(params => {
      let flag = false;
      if(params['course_id']){
        this.course_id = params['course_id'];
      }
      if(params['certId']){
        let id = params['certId'];
        if(id && id.includes('http')){
          flag = true;
          this.redirectUrl = decodeURIComponent(id);
        }else{
          this.certId = params['certId'];
          this.type = 'certificate';
        }
      }
      if(!flag){
        if(params['url']){
          let id = params['url'];
          if(id && id.includes('http')){
            this.redirectUrl = decodeURIComponent(id);
          }
        }
      }
    });

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let Role = localStorage.getItem('userRole');
    let language_id = localStorage.getItem('defaultLangId');
    this.translateService.get(['BUTTON_TITLE.LETS_GO', 'BUTTON_TITLE.START', 'SUBSCRIPTION_FORM.MODAL_TITILE', 'SUBSCIPTION_FORM.TERM', 'SUBSCRIPTION_FORM.COURSEPRICE', 'SUBSCRIPTION_FORM.ENTER_DISC_CODE', 'SUBSCRIPTION_FORM.COUPON_CODE', 'BUTTON_TITLE.APPLY', 'SUBSCRIPTION_FORM.DISCOUNT', 'SUBSCRIPTION_FORM.FINAL_PRICE_TEXT', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.PAY', 'SUBSCRIPTION_FORM.SERVER_VALIDATION_MSG.SUBSCRIPTION_FAILED', 'BUTTON_TITLE.OK', 'SUBSCRIPTION_FORM.SERVER_VALIDATION_MSG.SUBSCRIPTION_SUCCESS', 'RE_TYPE_PASSWORD.APPROVE', 'RE_TYPE_PASSWORD.RE_TYPE_PASSWORD', 'BUTTON_TITLE.CANCEL', 'BUTTON_TITLE.CONFIRM', 'SUBSCRIPTION_FORM.SUB_LICENSE', 'SUBSCRIPTION_FORM.OR', 'SUBSCRIPTION_FORM.CON_ERROR', 'SUBSCRIPTION_FORM.NT_ERROR', 'SUBSCRIPTION_FORM.NO_INTERNET', 'SUBSCRIPTION_FORM.NO_INT_MSG', 'NOTIFICATION.NOTIFICATION', 'EXTERNALIZED_COMPONENT.INVALID_CERTIFICATE', 'EXTERNALIZED_COMPONENT.INVALID_CERTIFICATE','SUBSCRIPTION_FORM.SERVER_VALIDATION_MSG.CERTIFICATE_ALREADY_SUBSCRIBED','SUBSCRIPTION_FORM.SERVER_VALIDATION_MSG.MODULE_ALREADY_SUBSCRIBED','EXTERNALIZED_COMPONENT.PLEASE_LOGIN_MSG', 'SUBSCRIPTION_FORM.SERVER_VALIDATION_MSG.NOT_AVAILABLE_TO_SUBSCRIBE','EXTERNALIZED_COMPONENT.INVALID_SESSION','EXTERNALIZED_COMPONENT.INVALID_MODULE','EXTERNALIZED_COMPONENT.NO_LICENSE_AVAILABLE','EXTERNALIZED_COMPONENT.NO_ASSIGNED_CERT_COURSE', 'SUBSCRIPTION_FORM.DESC_TEXT', 'SUBSCRIPTION_FORM.AND_TEXT']).subscribe(label => {
      this.buttonTitle = label;
    });
    if(Role && (Role == 'Learner' || Role == 'Manager')){
      if(currentUser && currentUser.user && currentUser.user.userid){
        this.userID = currentUser.user.userid;
        this.communityId = currentUser.user.community_id;

        if(this.communityId && this.course_id){
          if(this.type == 'certificate'){
            this.learnerService.getLatestCertificateById(this.certId, language_id).subscribe(result => {
              if(result.success){
                this.currentCourse = result.data;
                this.valArr = [];
                let obj = {
                  certId: this.certId,
                  course_id: this.course_id,
                  type: this.type,
                  user_id: this.userID,
                  communityId: this.communityId
                };
                this.learnerService.checkSubscriptionById(obj).subscribe(ch => {
                  if(ch.success){
                    if(ch.statusCode == '200'){
                      if(ch.data == true || ch.data && ch.data.length > 0){
                        this.learnerService.getLicenseByCertificateId(this.certId, this.communityId).subscribe(res => {
                          if (res.success) {
                            $("#preloader").css('display','none');
                            if (res.data) {
                              this.selectedLicense = res.data;
                              this.licensePrice = res.data.price;
                              this.TotalPrice = res.data.price;
                              this.DiscountPrice = 0;
                              this.coupon_code = '';
                              this.selectedLicense.paid_status == 'free' ? this.isFreeLicenseSelected = true : this.isFreeLicenseSelected = false;
                            } else {
                              this.isFreeLicenseSelected = true;
                              this.selectedLicense = res.data;
                              this.licensePrice = 0;
                              this.TotalPrice = 0;
                              this.DiscountPrice = 0;
                              this.coupon_code = '';
                            }
                            $('#subscribeModal').modal('show');

                            this.TotalPrice = 0;
                            let price = this.selectedLicense.price;
                            if (price == undefined) {
                              price = 0;
                            }

                            this.TotalPrice = price;
                            if (this.TotalPrice < 0) {
                              this.TotalPrice = 0;
                            }
                            let obj = {
                              licence_id: this.selectedLicense.licence_id,
                              licence_duration: this.selectedLicense.duration,
                              price: this.TotalPrice,
                              term: this.selectedLicense.term,
                              no_of_license: 1,
                              no_of_used_license: 1,
                              selected_courses: this.selectedLicense.selected_courses,
                              selected_certificates: this.selectedLicense.selected_certificates,
                              selected_journeys: this.selectedLicense.selected_journeys,
                              user_id: this.userID,
                              created_by: this.userID,
                              created_date: new Date().getTime(),
                              coupon_code: this.coupon_code,
                              community_id: this.communityId,
                              subscribed_by: 'Learner',
                              paidStatus: this.selectedLicense.paid_status,
                              original_price: this.TotalPrice,
                              no_of_coupons: 0,
                              licence_name: this.selectedLicense.licence_name
                            };
                            this.valArr.push(obj);

                            if (this.TotalPrice > 0) {
                            let couponData;
                            if (this.appliedCoupons != undefined && this.appliedCoupons != 0) {
                              couponData = {
                                coupon_id: this.coupon_id,
                                no_of_coupon_used: this.appliedCoupons
                              };
                              localStorage.setItem('saveCoupons', JSON.stringify(couponData));
                            }
                            $("#preloader").css('display', 'block');
                            const theUser = JSON.parse(localStorage.getItem('currentUser'));
                            let that = this;
                            let c_data = couponData ? JSON.stringify(couponData) : "";

                            let tokenData = {
                              user_id: this.userID,
                              price: this.TotalPrice,
                              url: '',
                              subscriptionData: this.valArr,
                              user_name: theUser.user.username,
                              fullname : theUser.user.fullname,
                              couponData: c_data,
                              licence_renew: false,
                              redirect_URL: '/dashboard/learner/learnerDashboard',
                              optional_params: JSON.stringify(this.valArr)
                            };
                            $('#msgDiv').remove();
                            $(".mainDiv").show();
                            $("#expressCheckoutDiv").show();
                            $("#paypal-button").empty();
                            paypal.Button.render({
                              env: Configuration.PayPal_Mode,
                              style: {
                                size: 'medium',
                                color: 'gold',
                                shape: 'rect',
                                label: 'checkout',
                                tagline: false,
                                height: 35
                              },
                              // Set up the payment:
                              // 1. Add a payment callback
                              payment: function (data, actions) {
                                // 2. Make a request to your server
                                return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/' + that.TotalPrice + '?token=' + theUser.token, tokenData)
                                .then(function (res) {
                                  // 3. Return res.id from the response
                                  return res.id;
                                });
                              },
                              // Execute the payment:
                              // 1. Add an onAuthorize callback
                              onAuthorize: function (data, actions) {
                              // 2. Make a request to your server
                                return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
                                  paymentID: data.paymentID,
                                  payerID: data.payerID,
                                })
                              .then(function (res) {
                              // 3. Show the buyer a confirmation message.

                              if (res.statusCode == 200) {
                                let AMT = res.data.price;
                                let PNREF = res.data.PNREF;

                                $(".mainDiv").hide();
                                $("#expressCheckoutDiv").hide();
                                let div = "<div id='msgDiv' style='text-align: center;'>" +
                                  '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                                  "<p style='font-family: Helvetica;color:#0072BC;'>Transaction Successfully Completed</p>" +
                                  '<br>' +
                                  '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Amount Paid</p>' +
                                  '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ ' + AMT + '</p>' +
                                  '<br>' +
                                  '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Transaction Id: <span style="font-family: Helvetica;color:#000;">' + PNREF + '</span></p>' +
                                  "</div>";
                                  $('#msgDiv').remove();
                                  $("#payPalModal").append(div);
                                  $('#subscribeModal').modal('hide');
                                  $('#learnerPayFlowModal').modal('show');
                                }
                              });
                            }
                          }, '#paypal-button');
                          setTimeout(() => {
                            $("#preloader").css('display', 'none');
                            $("#modulePayFlowFrameDiv").empty();
                          }, 500);
                        }
                          }
                        });
                      }else{
                        //alert Msg
                        this.alertMsg = '207';
                        $('#alertMsgModal').modal('show');
                        $("#preloader").css('display','none');
                      }
                    }else if(ch.statusCode == '201'){
                      //alert Msg
                      this.alertMsg = '200';
                      $('#alertMsgModal').modal('show');
                      $("#preloader").css('display','none');
                    }else if(ch.statusCode == '202'){
                      //alert Msg
                      this.alertMsg = '202';
                      $('#alertMsgModal').modal('show');
                      $("#preloader").css('display','none');
                    }else if(ch.statusCode == '203'){
                      //alert Msg
                      this.alertMsg = '208';
                      $('#alertMsgModal').modal('show');
                      $("#preloader").css('display','none');
                    }
                  }
                });
              }else{
                //Cert Id Not found
                this.alertMsg = '204';
                $('#alertMsgModal').modal('show');
                $("#preloader").css('display','none');
              }
            });
          }else if(this.type == 'course'){
            this.learnerService.getCourseById(this.course_id, language_id).subscribe(result => {
              if(result.success){
                this.currentCourse = result.data;
                let obj = {
                  certId: this.certId,
                  course_id: this.course_id,
                  type: this.type,
                  user_id: this.userID,
                  communityId: this.communityId
                };
                this.learnerService.checkSubscriptionById(obj).subscribe(ch => {
                  if(ch.success){
                    if(ch.statusCode == '200'){
                      if(ch.data == true || ch.data && ch.data.length > 0){
                        this.learnerService.getLisenseByCourse(this.course_id, this.communityId).subscribe(res => {
                          if(res.success){
                            this.isFreeLicenseSelected = false;
                            this.allLicense = res.data || [];
                            let _1Year = this.allLicense.find(element => {
                              if (element.term[0] == 'Year' && element.term[1] == 1) {
                                return element;
                              } 
                            });
                            let _2Year = this.allLicense.find(element => {
                              if (element.term[0] == 'Year' && element.term[1] == 2) {
                                return element;
                              } 
                            });
                            let _6Month = this.allLicense.find(element => {
                              if (element.term[0] == 'Month' && element.term[1] == 6) {
                                return element;
                              } 
                            });
                            let _1Month = this.allLicense.find(element => {
                              if (element.term[0] == 'Month' && element.term[1] == 1) {
                                return element;
                              } 
                            });
                            if (_1Year) {
                              this.selectedLicense = _1Year;
                            } else if (_2Year) {
                              this.selectedLicense = _2Year;
                            } else if (_6Month) {
                              this.selectedLicense = _6Month;
                            } else if (_1Month) {
                              this.selectedLicense = _1Month;
                            }
                            $("#preloader").css('display','none');
                            setTimeout(()=>{
                              $('#subscribeModal').modal('show');
                              $("#paypal-button").empty();
                            }, 500);
                            setTimeout(() => {
                              this.changeTerm();
                            }, 1000);
                          }
                        });
                      }else{
                        //alert Msg
                        this.alertMsg = '207';
                        $('#alertMsgModal').modal('show');
                        $("#preloader").css('display','none');
                      }
                    }else if(ch.statusCode == '203'){
                      //alert Msg
                      this.alertMsg = '208';
                      $('#alertMsgModal').modal('show');
                      $("#preloader").css('display','none');
                    }else{
                      //alert Msg
                      this.alertMsg = '201';
                      $('#alertMsgModal').modal('show');
                      $("#preloader").css('display','none');
                    }
                  }
                });

              }else{
                //Course Id Not found
                this.alertMsg = '203';
                $('#alertMsgModal').modal('show');
                $("#preloader").css('display','none');
              }
            });
          }
        }
      }else{
        this.alertMsg = '205';
        $('#alertMsgModal').modal('show');
        $("#preloader").css('display','none');
      }
    }else{
      this.alertMsg = '206';
      $('#alertMsgModal').modal('show');
      $("#preloader").css('display','none');
    }

  }

  closeModel(subscriptionForm){
    subscriptionForm.reset();
    this.couponValidationMsg = '';
    localStorage.removeItem('all_subscription_arr');
    this.TotalPrice = 0;
    this.DiscountPrice = 0;
    this.agreement = undefined;
    this.InvalidCoupon = false;
    setTimeout(()=>{
      this.selectedLicense = undefined;
    }, 500);
    $('#subscribeModal').modal('hide');
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  changeTerm(){
    this.coursesNamesStr = '';
    $("#paypal-button").empty();
    this.licensePrice = this.selectedLicense.price;
    this.valArr = [];
    this.selectedLicense.paid_status == 'free' ? this.isFreeLicenseSelected = true : this.isFreeLicenseSelected = false;
    this.TotalPrice = this.selectedLicense.price;
    this.DiscountPrice = 0;
    this.coupon_code = '';
    this.couponValidationMsg = '';
    if(this.valArr.length == 0){
      this.valArr = [];
      this.TotalPrice = 0;
      let price = this.selectedLicense.price;
      if(price == undefined){
        price = 0;
      }

      this.TotalPrice = price;
      if(this.TotalPrice < 0){
        this.TotalPrice = 0;
      }
      let obj = {
        licence_id: this.selectedLicense.licence_id,
        licence_duration: this.selectedLicense.duration,
        price: this.TotalPrice,
        term: this.selectedLicense.term,
        no_of_license: 1,
        no_of_used_license: 1,
        selected_courses: this.selectedLicense.selected_courses,
        selected_certificates: this.selectedLicense.selected_certificates,
        selected_journeys: this.selectedLicense.selected_journeys,
        user_id: this.userID,
        created_by: this.userID,
        created_date: new Date().getTime(),
        coupon_code: this.coupon_code,
        community_id: this.communityId,
        subscribed_by: 'Learner',
        paidStatus: this.selectedLicense.paid_status,
        original_price: this.TotalPrice,
        no_of_coupons: 0,
        licence_name : this.selectedLicense.licence_name
      };
      this.valArr.push(obj);
    }
    if(this.valArr && this.valArr.length > 0){
      let couponData;
      if(this.appliedCoupons != undefined && this.appliedCoupons != 0){
        couponData = {
          coupon_id: this.coupon_id,
          no_of_coupon_used: this.appliedCoupons
        };
        localStorage.setItem('saveCoupons', JSON.stringify(couponData));
      }

      if(this.TotalPrice > 0){
        let that = this;
        $("#preloader").css('display','block');
        localStorage.setItem('all_subscription_arr',JSON.stringify(this.valArr));
        const theUser = JSON.parse(localStorage.getItem('currentUser'));
        let c_data = couponData ? JSON.stringify(couponData) : "";

        let tokenData = {
          user_id: this.userID,
          price: this.TotalPrice,
          url : '',
          subscriptionData : this.valArr,
          user_name : theUser.user.username,
          fullname : theUser.user.fullname,
          couponData : c_data,
          licence_renew : false,
          redirect_URL : "/dashboard/learner/learnerDashboard",
          optional_params : JSON.stringify(this.valArr)
        };

        $('#msgDiv').remove();
        $(".mainDiv").show();
        $("#expressCheckoutDiv").show();
        $("#paypal-button").empty();
        paypal.Button.render({
          env: Configuration.PayPal_Mode,
          style: {
            size: 'medium',
            color: 'gold',
            shape: 'rect',
            label:'checkout',
            tagline : false,
            height: 35
          },
          // Set up the payment:
          // 1. Add a payment callback
          payment: function(data, actions) {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/'+ that.TotalPrice + '?token=' + theUser.token , tokenData)
              .then(function(res) {
                // 3. Return res.id from the response
                return res.id;
              });
          },
          // Execute the payment:
          // 1. Add an onAuthorize callback
          onAuthorize: function(data, actions) {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
              paymentID: data.paymentID,
              payerID:   data.payerID,
            })
              .then(function(res) {
                // 3. Show the buyer a confirmation message.

                if(res.statusCode == 200){
                  let AMT = res.data.price;
                  let PNREF = res.data.PNREF;

                  $(".mainDiv").hide();
                  $("#expressCheckoutDiv").hide();
                  let div = "<div id='msgDiv' style='text-align: center;'>" +
                    '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                    "<p style='font-family: Helvetica;color:#0072BC;'>Transaction Successfully Completed</p>" +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Amount Paid</p>' +
                    '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ '+ AMT +'</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Transaction Id: <span style="font-family: Helvetica;color:#000;">'+ PNREF +'</span></p>' +
                    "</div>";
                  $('#msgDiv').remove();
                  $("#payPalModal").append(div);
                  $('#subscribeModal').modal('hide');
                  $('#learnerPayFlowModal').modal('show');
                  $("#preloader").css('display','none');
                }
              });
          }
        }, '#paypal-button');


        setTimeout(()=>{
          // $('#subscribeModal').modal('hide');
          $("#preloader").css('display','none');
          /*$('#learnerPayFlowModal').modal('show');*/
          $("#payflowFrame").empty();
        }, 500);
      }else {
        $("#payflowFrame").empty();
      }
      if(this.selectedLicense && this.selectedLicense.selected_courses && this.selectedLicense.selected_courses.length > 1){
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        const community_id = currentUser.user.community_id;
        const lang_id = localStorage.getItem('defaultLangId');
        let obj = {
          community_id: community_id,
          courseIdArr: this.selectedLicense.selected_courses,
          lang_id: lang_id
        };
        $("#preloader").css('display','block');
        this.learnerService.getLisenceCourseName(obj).subscribe(crs=> {
          if(crs.success && crs.data && crs.data.length > 0){
            this.coursesNamesStr = '';
            let str = '' + crs.data[0].name;
            if(crs.data.length == 2){
              this.coursesNamesStr = '' + crs.data[0].name + ' '+ this.buttonTitle['SUBSCRIPTION_FORM.AND_TEXT'] +' ' + crs.data[1].name;
              $("#preloader").css('display','none');
            }else{
              for(let a=1; a< crs.data.length ; a++){
                if(a == crs.data.length-1){
                  str += ' '+ this.buttonTitle['SUBSCRIPTION_FORM.AND_TEXT'] +' ' + crs.data[a].name;
                }else{
                  str += ', ' + crs.data[a].name;
                }
              }
              this.coursesNamesStr = str;
              $("#preloader").css('display','none');
            }

          }else{
            $("#preloader").css('display','none');
          }
        });
      }
    }else{

    }
  }

  checkCouponCode(){
    this.couponValidationMsg = "";
    if(this.coupon_code == ''){
      $("#paypal-button").empty();
      this.valArr = [];
      this.TotalPrice = 0;
      this.appliedCoupons = 0;
      this.DiscountPrice = 0;
      let price = this.selectedLicense.price;
      if(price == undefined){
        price = 0;
      }

      this.TotalPrice = price;
      if(this.TotalPrice < 0){
        this.TotalPrice = 0;
      }
      let obj = {
        licence_id: this.selectedLicense.licence_id,
        licence_duration: this.selectedLicense.duration,
        price: this.TotalPrice,
        term: this.selectedLicense.term,
        no_of_license: 1,
        no_of_used_license: 1,
        selected_courses: this.selectedLicense.selected_courses,
        selected_certificates: this.selectedLicense.selected_certificates,
        selected_journeys: this.selectedLicense.selected_journeys,
        user_id: this.userID,
        created_by: this.userID,
        created_date: new Date().getTime(),
        coupon_code: this.coupon_code,
        community_id: this.communityId,
        subscribed_by: 'Learner',
        paidStatus: this.selectedLicense.paid_status,
        original_price: this.TotalPrice,
        no_of_coupons: 0,
        licence_name : this.selectedLicense.licence_name
      };
      this.valArr.push(obj);
      if(this.TotalPrice > 0){
        this.paypalButton();
      } else {
        $("#paypal-button").empty();
      }
    }
  }

  paypalButton(){
    let couponData;
    if(this.appliedCoupons != undefined && this.appliedCoupons != 0){
      couponData = {
        coupon_id: this.coupon_id,
        no_of_coupon_used: this.appliedCoupons
      };
      localStorage.setItem('saveCoupons', JSON.stringify(couponData));
    }

    let that = this;
    $("#preloader").css('display','block');
    localStorage.setItem('all_subscription_arr',JSON.stringify(this.valArr));
    const theUser = JSON.parse(localStorage.getItem('currentUser'));
    let c_data = couponData ? JSON.stringify(couponData) : "";

    let tokenData = {
      user_id: this.userID,
      price: this.TotalPrice,
      url : '',
      subscriptionData : this.valArr,
      user_name : theUser.user.username,
      fullname : theUser.user.fullname,
      couponData : c_data,
      licence_renew : false,
      redirect_URL : "/dashboard/learner/learnerDashboard",
      optional_params : JSON.stringify(this.valArr)
    };

    $('#msgDiv').remove();
    $(".mainDiv").show();
    $("#expressCheckoutDiv").show();
    $("#paypal-button").empty();
    paypal.Button.render({
      env: Configuration.PayPal_Mode,
      style: {
        size: 'medium',
        color: 'gold',
        shape: 'rect',
        label:'checkout',
        tagline : false,
        height: 35
      },
      // Set up the payment:
      // 1. Add a payment callback
      payment: function(data, actions) {
        // 2. Make a request to your server
        return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/'+ that.TotalPrice + '?token=' + theUser.token , tokenData)
          .then(function(res) {
            // 3. Return res.id from the response
            return res.id;
          });
      },
      // Execute the payment:
      // 1. Add an onAuthorize callback
      onAuthorize: function(data, actions) {
        // 2. Make a request to your server
        return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
          paymentID: data.paymentID,
          payerID:   data.payerID,
        })
          .then(function(res) {
            // 3. Show the buyer a confirmation message.

            if(res.statusCode == 200){
              let AMT = res.data.price;
              let PNREF = res.data.PNREF;

              $(".mainDiv").hide();
              $("#expressCheckoutDiv").hide();
              let div = "<div id='msgDiv' style='text-align: center;'>" +
                '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                "<p style='font-family: Helvetica;color:#0072BC;'>Transaction Successfully Completed</p>" +
                '<br>' +
                '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Amount Paid</p>' +
                '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ '+ AMT +'</p>' +
                '<br>' +
                '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Transaction Id: <span style="font-family: Helvetica;color:#000;">'+ PNREF +'</span></p>' +
                "</div>";
              $('#msgDiv').remove();
              $("#payPalModal").append(div);
              $('#subscribeModal').modal('hide');
              $('#learnerPayFlowModal').modal('show');
              $("#preloader").css('display','none');
            }
          });
      }
    }, '#paypal-button');
    setTimeout(()=>{
      // $('#subscribeModal').modal('hide');
      $("#preloader").css('display','none');
      /*$('#learnerPayFlowModal').modal('show');*/
      $("#payflowFrame").empty();
    }, 500);
  }

  applyCoupon(){
    $("#paypal-button").empty();
    this.DiscountPrice = 0;
    this.valArr = [];
    let TotalPrice = 0;
    this.TotalPrice = 0;
    let availableCoupons = 0;
    let usedCoupons = 0;
    if(!this.coupon_code){
      this.couponValidationMsg = "103";
      this.InvalidCoupon = true;
      let price = this.selectedLicense.price;
      if(price == undefined){
        price = 0;
      }

      this.TotalPrice = price;
      if(this.TotalPrice<0){
        this.TotalPrice = 0;
        this.DiscountPrice = 0.00;
      }
      let obj = {
        licence_id: this.selectedLicense.licence_id,
        licence_duration: this.selectedLicense.duration,
        price: this.TotalPrice,
        term: this.selectedLicense.term,
        no_of_license: 1,
        no_of_used_license: 1,
        selected_courses: this.selectedLicense.selected_courses,
        selected_certificates: this.selectedLicense.selected_certificates,
        selected_journeys: this.selectedLicense.selected_journeys,
        user_id: this.userID,
        created_by: this.userID,
        created_date: new Date().getTime(),
        coupon_code: this.coupon_code,
        community_id: this.communityId,
        subscribed_by: 'Learner',
        paidStatus: this.selectedLicense.paid_status,
        original_price: this.TotalPrice,
        no_of_coupons: 0,
        licence_name : this.selectedLicense.licence_name
      };
      this.valArr.push(obj);
    }else {
      this.InvalidCoupon = false;
      this.appliedCoupons = 0;
      this.learnerService.getCouponsByCode(this.coupon_code,this.communityId).subscribe(coupandata =>{
        this.couponValidationMsg = coupandata.statusCode;
        if(coupandata.success == true){
          this.coupon_id = coupandata.data.coupon_id;
          if(coupandata.data.no_of_coupon_used == undefined){
            usedCoupons = 0;
          }else {
            usedCoupons = coupandata.data.no_of_coupon_used;
          }
          if(usedCoupons == coupandata.data.no_of_coupon_ava){
            this.couponValidationMsg = "101";
            this.InvalidCoupon = true;
            let price = this.selectedLicense.price;
            if(price == undefined){
              price = 0;
            }

            this.TotalPrice = price;
            if(this.TotalPrice<0){
              this.TotalPrice = 0;
            }
            let obj = {
              licence_id: this.selectedLicense.licence_id,
              licence_duration: this.selectedLicense.duration,
              price: this.TotalPrice,
              term: this.selectedLicense.term,
              no_of_license: 1,
              no_of_used_license: 1,
              selected_courses: this.selectedLicense.selected_courses,
              selected_certificates: this.selectedLicense.selected_certificates,
              selected_journeys: this.selectedLicense.selected_journeys,
              user_id: this.userID,
              created_by: this.userID,
              created_date: new Date().getTime(),
              coupon_code: this.coupon_code,
              community_id: this.communityId,
              subscribed_by: 'Learner',
              paidStatus: this.selectedLicense.paid_status,
              original_price: this.TotalPrice,
              no_of_coupons: 0,
              licence_name : this.selectedLicense.licence_name
            };
            this.valArr.push(obj);
          }else {
            let original_price = 0;
            let no_of_coupons = 0;
            this.appliedCoupons = usedCoupons;
            availableCoupons = coupandata.data.no_of_coupon_ava - usedCoupons;
            let price = this.selectedLicense.price;
            if(price == undefined){
              price = 0;
            }
            let nooflicense = 1;
            original_price = price;
            if(coupandata.data.coupon_type == 'Number Based'){
              if(coupandata.data.discount_type == "Price"){
                TotalPrice = 0;
                if(availableCoupons>0){
                  const total =price- coupandata.data.discount;
                  TotalPrice = TotalPrice + total;
                  availableCoupons--;
                  this.appliedCoupons++;
                  no_of_coupons = 1;
                }else {
                  TotalPrice = TotalPrice + price;
                }
                this.TotalPrice = this.TotalPrice + TotalPrice;
                if(this.TotalPrice<0){
                  this.TotalPrice = 0;
                  this.DiscountPrice = price;
                }else{
                  this.DiscountPrice = price - this.TotalPrice;
                }
              }else if(coupandata.data.discount_type == "Percentage"){
                TotalPrice = 0;
                if(availableCoupons>0){
                  const total =price- (price * coupandata.data.discount)/100;
                  TotalPrice = TotalPrice + total;
                  availableCoupons--;
                  this.appliedCoupons++;
                  no_of_coupons = 1;
                }else {
                  TotalPrice = TotalPrice + price;
                }
                this.TotalPrice = this.TotalPrice + TotalPrice;
                if(this.TotalPrice<0){
                  this.TotalPrice = 0;
                  this.DiscountPrice = price;
                }else{
                  this.DiscountPrice = price - this.TotalPrice;
                }
              }
            }else if(coupandata.data.coupon_type == 'Time Based') {
              this.appliedCoupons = undefined;
              const today = new Date();
              let currDate = new Date((today.getMonth()+1)+"/"+(today.getDate())+"/"+today.getFullYear()).getTime();
              if(currDate < coupandata.data.start_date){
                this.couponValidationMsg = "202";
                this.InvalidCoupon = true;
                const total = nooflicense * price;
                no_of_coupons = 0;
                this.TotalPrice = this.TotalPrice + total;
                if(this.TotalPrice<0){
                  this.TotalPrice = 0;
                  this.DiscountPrice = price;
                }else{
                  this.DiscountPrice = price - this.TotalPrice;
                }
              }else if(currDate >= coupandata.data.start_date && currDate <= coupandata.data.end_date){
                if(coupandata.data.discount_type == "Price"){
                  TotalPrice = 0;
                  const total =price- coupandata.data.discount;
                  TotalPrice = TotalPrice + total;
                  no_of_coupons = 1;
                  this.TotalPrice = this.TotalPrice + TotalPrice;
                  if(this.TotalPrice<0){
                    this.TotalPrice = 0;
                    this.DiscountPrice = price;
                  }else{
                    this.DiscountPrice = price - this.TotalPrice;
                  }
                }else if(coupandata.data.discount_type == "Percentage"){
                  TotalPrice = 0;
                  const total =price- (price * coupandata.data.discount)/100;
                  TotalPrice = TotalPrice + total;
                  no_of_coupons = 1;
                  this.TotalPrice = this.TotalPrice + TotalPrice;
                  if(this.TotalPrice<0){
                    this.TotalPrice = 0;
                    this.DiscountPrice = price;
                  }else{
                    this.DiscountPrice = price - this.TotalPrice;
                  }
                }
              }else {
                this.couponValidationMsg = "102";
                this.InvalidCoupon = true;
                const total = nooflicense * price;
                no_of_coupons = 0;
                this.TotalPrice = this.TotalPrice + total;
                if(this.TotalPrice<0){
                  this.TotalPrice = 0;
                }
              }
            }
            let obj = {
              licence_id: this.selectedLicense.licence_id,
              licence_duration: this.selectedLicense.duration,
              price: this.TotalPrice,
              term: this.selectedLicense.term,
              no_of_license: 1,
              no_of_used_license: 1,
              selected_courses: this.selectedLicense.selected_courses,
              selected_certificates: this.selectedLicense.selected_certificates,
              selected_journeys: this.selectedLicense.selected_journeys,
              user_id: this.userID,
              created_by: this.userID,
              created_date: new Date().getTime(),
              coupon_code: this.coupon_code,
              community_id: this.communityId,
              subscribed_by: 'Learner',
              paidStatus: this.selectedLicense.paid_status,
              original_price: original_price,
              no_of_coupons: no_of_coupons,
              licence_name : this.selectedLicense.licence_name
            };
            this.valArr.push(obj);
          }
        }else {

          this.couponValidationMsg = coupandata.statusCode;
          this.InvalidCoupon = true;
          let price = this.selectedLicense.price;
          if(price == undefined){
            price = 0;
          }
          let nooflicense = 1;
          const total = nooflicense * price;
          this.TotalPrice = this.TotalPrice + total;
          if(this.TotalPrice<0){
            this.TotalPrice = 0;
          }
          let obj = {
            licence_id: this.selectedLicense.licence_id,
            licence_duration: this.selectedLicense.duration,
            price: this.TotalPrice,
            term: this.selectedLicense.term,
            no_of_license: 1,
            no_of_used_license: 1,
            selected_courses: this.selectedLicense.selected_courses,
            selected_certificates: this.selectedLicense.selected_certificates,
            selected_journeys: this.selectedLicense.selected_journeys,
            user_id: this.userID,
            created_by: this.userID,
            created_date: new Date().getTime(),
            coupon_code: this.coupon_code,
            community_id: this.communityId,
            subscribed_by: 'Learner',
            paidStatus: this.selectedLicense.paid_status,
            original_price: this.TotalPrice,
            no_of_coupons: 0,
            licence_name : this.selectedLicense.licence_name
          };
          this.valArr.push(obj);
        }

        if(this.TotalPrice > 0){
          this.paypalButton();
        } else {
          $("#paypal-button").empty();
        }
      });
    }
  }

  subscribeLicense(subscriptionForm){
    $('#msgDiv').remove();
    $("#paypal-button").empty();
    if(this.valArr.length == 0){
      this.valArr = [];
      this.TotalPrice = 0;
      let price = this.selectedLicense.price;
      if(price == undefined){
        price = 0;
      }

      this.TotalPrice = price;
      if(this.TotalPrice < 0){
        this.TotalPrice = 0;
      }
      let obj = {
        licence_id: this.selectedLicense.licence_id,
        licence_duration: this.selectedLicense.duration,
        price: this.TotalPrice,
        term: this.selectedLicense.term,
        no_of_license: 1,
        no_of_used_license: 1,
        selected_courses: this.selectedLicense.selected_courses,
        selected_certificates: this.selectedLicense.selected_certificates,
        selected_journeys: this.selectedLicense.selected_journeys,
        user_id: this.userID,
        created_by: this.userID,
        created_date: new Date().getTime(),
        coupon_code: this.coupon_code,
        community_id: this.communityId,
        subscribed_by: 'Learner',
        paidStatus: this.selectedLicense.paid_status,
        original_price: this.TotalPrice,
        no_of_coupons: 0,
        licence_name : this.selectedLicense.licence_name
      };
      this.valArr.push(obj);
    }
    if(this.valArr && this.valArr.length > 0){
      let couponData;
      if(this.appliedCoupons != undefined && this.appliedCoupons != 0){
        couponData = {
          coupon_id: this.coupon_id,
          no_of_coupon_used: this.appliedCoupons
        };
        localStorage.setItem('saveCoupons', JSON.stringify(couponData));
      }

      if(this.TotalPrice > 0){

        let that = this;
        $("#preloader").css('display','block');
        localStorage.setItem('all_subscription_arr',JSON.stringify(this.valArr));
        const theUser = JSON.parse(localStorage.getItem('currentUser'));
        let c_data = couponData ? JSON.stringify(couponData) : "";

        let tokenData = {
          user_id: this.userID,
          price: this.TotalPrice,
          url : '',
          subscriptionData : this.valArr,
          user_name : theUser.user.username,
          fullname : theUser.user.fullname,
          couponData : c_data,
          licence_renew : false,
          redirect_URL : "/dashboard/learner/learnerDashboard",
          optional_params : JSON.stringify(this.valArr)
        };

        $('#msgDiv').remove();
        $(".mainDiv").show();
        $("#expressCheckoutDiv").show();
        $("#paypal-button").empty();
        paypal.Button.render({
          env: Configuration.PayPal_Mode,
          style: {
            size: 'medium',
            color: 'gold',
            shape: 'rect',
            label:'checkout',
            tagline : false,
            height: 35
          },
          // Set up the payment:
          // 1. Add a payment callback
          payment: function(data, actions) {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/create-payment/'+ that.TotalPrice + '?token=' + theUser.token , tokenData)
              .then(function(res) {
                // 3. Return res.id from the response
                return res.id;
              });
          },
          // Execute the payment:
          // 1. Add an onAuthorize callback
          onAuthorize: function(data, actions) {
            // 2. Make a request to your server
            return actions.request.post(Configuration.ServerWithApiUrl + '/paypal-api/execute-payment/' + that.TotalPrice + '?token=' + theUser.token, {
              paymentID: data.paymentID,
              payerID:   data.payerID,
            })
              .then(function(res) {
                // 3. Show the buyer a confirmation message.

                if(res.statusCode == 200){
                  let AMT = res.data.price;
                  let PNREF = res.data.PNREF;

                  $(".mainDiv").hide();
                  $("#expressCheckoutDiv").hide();
                  let div = "<div id='msgDiv' style='text-align: center;'>" +
                    '<i class="fa fa-check-circle" aria-hidden="true" style="font-size:40px;color:#8EC63F;"></i>' +
                    "<p style='font-family: Helvetica;color:#0072BC;'>Transaction Successfully Completed</p>" +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Amount Paid</p>' +
                    '<p style="font-family: Helvetica;color:#000;margin: 5px 0;font-size: 26px;font-weight: bold;">$ '+ AMT +'</p>' +
                    '<br>' +
                    '<p style="font-family: Helvetica;color:#777;margin: 5px 0;">Transaction Id: <span style="font-family: Helvetica;color:#000;">'+ PNREF +'</span></p>' +
                    "</div>";
                  $('#msgDiv').remove();
                  $("#payPalModal").append(div);
                }
              });
          }
        }, '#paypal-button');


        setTimeout(()=>{
        $('#subscribeModal').modal('hide');
        $("#preloader").css('display','none');
        $('#learnerPayFlowModal').modal('show');
        $("#payflowFrame").empty();
        }, 500);


      }else {
        let coupons = JSON.parse(localStorage.getItem('saveCoupons'));
        if(coupons != null && this.selectedLicense.paid_status == 'paid'){
          this.learnerService.updateUsedCoupos(coupons).subscribe(res =>{
            localStorage.removeItem('saveCoupons');
          });
        }
        this.learnerService.saveLicenseForUser(this.valArr).subscribe( res => {
          this.subscribeLicIdList =  res.data;
          this.subStatusCode = res.statusCode;
          this.valArr = [];
          if(res.success){
            $('#subscribeModal').modal('hide');
            $('#successModal').modal('show');

          }
        });
      }
    }else{

    }
  }

  closePlaFlowModal(){
    this.subscriptionForm.reset();
    this.couponValidationMsg = '';
    localStorage.removeItem('all_subscription_arr');
    this.TotalPrice = 0;
    this.DiscountPrice = 0;
    this.InvalidCoupon = false;
    this.selectedLicense = undefined;
    this.coupon_id = undefined;
    this.appliedCoupons = 0;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.userID = currentUser.user.userid;
    this.communityId = currentUser.user.community_id;

    $('#msgDiv').remove();
    $("#payflowFrame").empty();
    $("#paypal-button").empty();
    $('#learnerPayFlowModal').modal('hide');
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  closeSuccessModal(){
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  closeAlertMsgModal(){
    if(this.redirectUrl != ''){
      $('#alertMsgModal').modal('hide');
      location.replace(this.redirectUrl);
    }else{
      $('#alertMsgModal').modal('hide');
      window.close();
    }
    this.alertMsg = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-subscription/isolated-subscription.component.ts